var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{attrs:{"value":_vm.activeTab},on:{"tab-click":_vm.onTabClick}},[_c('el-tab-pane',{attrs:{"label":"Locations","name":"locations"}}),_c('el-tab-pane',{attrs:{"label":"Map","name":"map"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }